import api from './api';
import furtherAuthAPI from './furtherAuth';
import frontend from './frontend';
import pdf from './pdf';
import sso from './sso';
import storage from './storage';
import taxDocs from './taxDocs';

const API_PATH = process.env.VUE_APP_API_PATH;
const API_VERSION = process.env.VUE_APP_API_VERSION;
const V2 = `-v2`;

const ACCOUNT_API_URL = `${API_PATH}/${API_VERSION}`;
const ACCOUNT_API_SUB_URLS = {
    accounts: `${ACCOUNT_API_URL}/accounts`,
    beneficiaries: `${ACCOUNT_API_URL}/beneficiaries`,
    investments: `${ACCOUNT_API_URL}/investments`,
    members: `${ACCOUNT_API_URL}/members`,
    scheduledDeposits: `${ACCOUNT_API_URL}/scheduled-deposits`,
};

const ADDRESS_VALIDATION_API_URL = `${API_PATH}/${API_VERSION}`;
const ADDRESS_VALIDATION_API_SUB_URLS = {
  addresses: `${ADDRESS_VALIDATION_API_URL}/addresses`,
  emails: `${ADDRESS_VALIDATION_API_URL}/emails`,
};

const BANK_API_URL = `${API_PATH}/${API_VERSION}`;
const BANK_API_SUB_URLS = {
  banks: `${BANK_API_URL}/banks`,
  bankAccounts: `${BANK_API_URL}/bank-accounts${V2}`,
  members: `${BANK_API_URL}/members`,
};

const CLAIM_API_URL = `${API_PATH}/${API_VERSION}`;
const CLAIM_API_SUB_URLS = {
  claims: `${CLAIM_API_URL}/claims`,
  onlineClaims: `${CLAIM_API_URL}/online-claims`,
  members: `${CLAIM_API_URL}/members`,
};

const GROUP_API_URL = `${API_PATH}/${API_VERSION}`;
const GROUP_API_URL_SUB_URLS = {
  groupComponents: `${GROUP_API_URL}/group-components`,
  groups: `${GROUP_API_URL}/groups`,
  users: `${GROUP_API_URL}/users`,
};

const MEMBER_API_URL = `${API_PATH}/${API_VERSION}`;
const MEMBER_API_SUB_URLS = {
  aris: `${MEMBER_API_URL}/aris${V2}`,
  debitCards: `${MEMBER_API_URL}/debit-cards`,
  dependents: `${MEMBER_API_URL}/dependents`,
  members: `${MEMBER_API_URL}/members`,
  messages: `${MEMBER_API_URL}/messages`,
  users: `${MEMBER_API_URL}/users`,
  mfaCodes: `${MEMBER_API_URL}/mfa-codes`,
  interestRates: `${MEMBER_API_URL}/interest-rates`,
};

const PROVIDER_API_URL = `${API_PATH}/${API_VERSION}`;
const PROVIDER_API_SUB_URLS = {
  members: `${PROVIDER_API_URL}/members`,
  providers: `${PROVIDER_API_URL}/providers`,
};

const REFERENCE_API_URL = `${API_PATH}/${API_VERSION}`;
const REFERENCE_API_SUB_URLS = {
  references: `${REFERENCE_API_URL}/references`,
};

const TAX_DOCS_API_URL = `${API_PATH}/${API_VERSION}`;
const TAX_DOCS_API_SUB_URLS = {
  request1099: `${TAX_DOCS_API_URL}/request-1099`,
  request5498: `${TAX_DOCS_API_URL}/request-5498`,
  taxYears: `${TAX_DOCS_API_URL}/tax-years`,
};

const VAULT_API_URL = `${API_PATH}/${API_VERSION}`;
const VAULT_API_SUB_URLS = {
  members: `${VAULT_API_URL}/members`,
  keys: `${VAULT_API_URL}/keys`,
  vaultData: `${VAULT_API_URL}/vault-data`,
};

const WIRED_COMMUTE_API_URL = `${API_PATH}/${API_VERSION}`;
const WIRED_COMMUTE_API_SUB_URLS = {
  wiredCommuteSso: `${WIRED_COMMUTE_API_URL}/members`,
};

const HEALTHEQUITY_API_URL = `${API_PATH}/${API_VERSION}`;
const HEALTHEQUITY_API_SUB_URLS = {
  healthEquitySso: `${HEALTHEQUITY_API_URL}/members`,
};

const REGISTRATION_API_URL = `${API_PATH}/${API_VERSION}/clients/member`;

const FURTHER_MEMBER_AUTHENTICATION_API_URL = `${API_PATH}/${API_VERSION}`;
const FURTHER_MEMBER_AUTHENTICATION_API_SUB_URLS = {
  tokens: `${FURTHER_MEMBER_AUTHENTICATION_API_URL}/tokens`,
  session:  `${FURTHER_MEMBER_AUTHENTICATION_API_URL}/sessions/details/me`,
};

const FURTHER_MEMBER_FEDERATION_API_URL = `${API_PATH}/${API_VERSION}`;
const FURTHER_MEMBER_FEDERATION_API_SUB_URLS = {
  jwt: `${FURTHER_MEMBER_FEDERATION_API_URL}/sessions/assume-member`,
};

export {
  api,
  furtherAuthAPI,
  frontend,
  pdf,
  sso,
  storage,
  taxDocs,
  ACCOUNT_API_SUB_URLS,
  ADDRESS_VALIDATION_API_SUB_URLS,
  BANK_API_SUB_URLS,
  CLAIM_API_SUB_URLS,
  FURTHER_MEMBER_AUTHENTICATION_API_SUB_URLS,
  FURTHER_MEMBER_FEDERATION_API_SUB_URLS,
  GROUP_API_URL_SUB_URLS,
  MEMBER_API_SUB_URLS,
  PROVIDER_API_SUB_URLS,
  REFERENCE_API_SUB_URLS,
  TAX_DOCS_API_SUB_URLS,
  VAULT_API_SUB_URLS,
  WIRED_COMMUTE_API_SUB_URLS,
  HEALTHEQUITY_API_SUB_URLS,
  REGISTRATION_API_URL,
  V2,
};